import { Pipe, PipeTransform } from '@angular/core';
import { FacebookService, InitParams } from 'ngx-facebook';
import { Observable } from 'rxjs';

@Pipe({
  name: 'idToFbPP'
})
export class IdToFbPP implements PipeTransform {

  constructor(private fb: FacebookService) {
    const initParams: InitParams = {
      appId: '343090895841828',
      xfbml: true,
      version: 'v2.8'
    };
    if (fb && window['FB']) { fb.init(initParams); }
  }

  transform(user_id: any, args?: any): any {
    if (!this.fb) {
      return new Observable(observer => {
        observer.next('../assets/img/avatar-white.png');
      });
    } else {
      return this.fb.api('/' + user_id + '/picture/?type=large&redirect=false')
        .then(res => {
          console.log('Called FB picture graph');
          return res['data']['url'];
        }).catch(e => console.error(e));
    }

  }

}
